import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { KatButton } from '@amzn/katal-react';
import { CountryCode } from '../urls-config';
import { BrandRegistryInfoAlertBox } from './BrandRegistryInfoAlertBox';
import { AuthenticationState } from './hooks/useTrimContext';

interface NoticeFormSignInProps {
  authenticationState?: AuthenticationState ;
  domainCountryCode: CountryCode;
}

const NoticeFormSignIn: React.FC<NoticeFormSignInProps> = (props: NoticeFormSignInProps) => {
  const { t } = useTranslation('pnf_website_components');
  const { authenticationState, domainCountryCode } = props;
  const handleSignInClick = () => {
    window.location.href = authenticationState?.signInUrl || '';
  };
  return (
    <div className="page-padding">
      {/* Page container for page level padding */}
      <Row className="d-flex justify-content-between">
        <Col xs="6">
          <Row className="pt-4">
            <Col xs="12">
              <h1>{t('public-notice-form-header')}</h1>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col xs="12">
              <h2>{t('public-notice-form-required-sign-in-auth-title')}</h2>
              <p>
                {t('public-notice-form-submit-infringement-report')}
              </p>
              <KatButton
                id="pnf-website-sign-in-button"
                variant="primary"
                onClick={handleSignInClick}
              >
                {t('public-notice-form-sign-in-button')}
              </KatButton>
              <span className="pl-1" id="create-account">
                {t('public-notice-form-required-sign-in-new-to-amazon')}
                <a className="pl-1" href={authenticationState?.registerUrl}>
                  {t('public-notice-form-required-sign-in-create-an-account')}
                </a>
              </span>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col xs="12">
              <h2>{t('public-notice-form-instructions-title')}</h2>
              {/* TODO: Deprecate country specific strings; generate links with string interpolation */}
              <span dangerouslySetInnerHTML={{ __html:
                  t([`public-notice-form-instructions-${domainCountryCode.toLowerCase()}`,
                    'public-notice-form-instructions']) }}
              />
            </Col>
          </Row>
          <Row className="pt-2">
            <Col xs="12">
              <h2>{t('public-notice-form-we-do-not-enforce-title')}</h2>
              {/*
               TODO: Deprecate country specific strings; split string content to render
                based on what is supported in the domain marketplace
               */}
              <span dangerouslySetInnerHTML={{ __html:
                  t([`public-notice-form-we-do-not-enforce-instructions-${domainCountryCode.toLowerCase()}`,
                    'public-notice-form-we-do-not-enforce-instructions']) }}
              />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <BrandRegistryInfoAlertBox domainCountryCode={domainCountryCode} />
        </Col>
      </Row>
    </div>
  );
};
export default NoticeFormSignIn;
